import React, { useEffect, useState } from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import bannerHero from './../assets/successpayf.png';
import MainFooter from '../Components/footer/MainFooter';
import { Helmet } from 'react-helmet';

function PaymentSuccess() {
    const {user}                                                   = useSelector((state) => state.auth);

    const location                                                 = useLocation();
    const [sessionId, setSessionId]                                = useState(null);
  
    useEffect(() => {
      //executeSuccefullPurchase();
    
    },[])

    const executeSuccefullPurchase = async () => {
      try{
        
        const queryParams = new URLSearchParams(location.search);
          const id = queryParams.get('session_id');
          if (id) {
            /////////
            setSessionId(id);
            
            console.log('Session ID:', id);
            // You can now fetch session details or confirm payment

            const res = await axios.post(`${CONSTANTS.API_URL}payment/complete/stripe/v1/order?session_id=${id}`, {
                            headers: { 
                                'token': 'Bearer ' + user.accessToken
                          }
                        });

                console.log(res);
            ///////
          }

      }catch(err){
        console.log(err);
      }
    }


  return (
    <div className="main-layer">
        <Helmet>
           <title>Lovedripp - Payment successful </title>
        </Helmet>
        <TopNavigation title={"Payment Successful"} classBack="full-white"/>
        <div className="content-layer">
            <div className="banner-photo-show middle-align txt-white short-banner" 
                style={{backgroundImage: `url("${bannerHero}")`}}>     
                <div className="info-hero-intro">
                    <h1>Successfully PAID</h1>                    
                </div>                 
            </div>
             <div className="section-item">             
                <div className="container">
                    <div className="place-middle">
                      <p>
                        Thank you for your payment, feature granted.
                      </p>
                      
                      <Link to={"/onsites"} className="btn btn-main">
                        Onsites
                      </Link>
                      <Link to={"/annisites"} className="btn btn-main">
                        Annisites
                      </Link>
                    </div>

                </div>
            </div>
        </div>
        <MainFooter />
    </div>
  )
}

export default PaymentSuccess